import script from "./WageWholeVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageWholeVersion.vue?vue&type=script&setup=true&lang=ts"

import "./WageWholeVersion.vue?vue&type=style&index=0&id=3928e1d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3928e1d9"]])

export default __exports__